// import libraries
const uuidv5 = require('uuid/v5')
const detect = require('../assets/detect.js').default;
const md = require('markdown-it')();

// define function outside that needs to be used
// in both classes instead of defining it twice
function checkDateString(ds) {
  // checks a `dateString` in the form of YYYY-MM-DD againsta regex
  if (new RegExp(/^([0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])$/g).test(ds)) {
    return true
  } else {
    return false
  }
}

export class Entry {
  constructor(constructObject) {
    // props in constructObject:
    // journal (class), content, forDay, creationDateTime, modifiedDateTime, tags, creationDeviceData

    // check datestring for the entry is correct
    if (!checkDateString(constructObject.forDay)) {
      throw new TypeError('Invalid DateString passed to Entry constructor.')
    }

    // convert modification & creation timestamps back to time objects
    constructObject.creationDateTime = new Date(constructObject.creationDateTime);
    constructObject.modifiedDateTime = new Date(constructObject.modifiedDateTime);

    // duplicate properties to class
    Object.assign(this, constructObject)

    // create uuid
    this.uuid = uuidv5(constructObject.forDay, this.journal.uuid)
    // create forDate
    this.forDate = new Date(constructObject.forDay)
  }
  toJSON() {
    // don't return journal in JSON or infinite loop (circular reference)
    var pack = {
      uuid: this.uuid,
      content: this.content,
      forDay: this.forDay,
      creationDateTime: this.creationDateTime,
      modifiedDateTime: this.modifiedDateTime,
      tags: this.tags,
      creationDeviceData: this.creationDeviceData
    }
    return pack
  }
  getUUID() {
    // simple get method in case UUID format/assigning was to change
    return this.uuid
  }
  getMonthName() {
    // Simple function for returning 3-character month
    return [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ][this.forDate.getMonth()]
  }
  getWords() {
    // use a regex to count words in content
    var str = this.content;
    const re = /\w/g;
    return ((str || '').match(re) || []).length;
  }
  getPreviewLine(line = 0) {
    // split by line then render markdown to return
    var lines = this.content.split('\n')
    if (lines.length <= line) {
      return '(empty)'
    }
    return md.render(lines[line]).replace(/<[^>]*>?/gm, '');
  }
}

export class Journal {
  constructor(constructObject) {
    // props in constructObject:
    // name, ownerUUID, entries, defaultText

    // duplicate properties to class & gen uuid
    Object.assign(this, constructObject)
    this.uuid = uuidv5(constructObject.name.toLowerCase(), constructObject.ownerUUID)

    // define entries object if not existent yet
    if (this.entries == undefined) {
      this.entries = {}
    } else {
      // if provided, recreate as Entry classes and add journal ref back
      for (var entry in this.entries) {
        if (this.entries.hasOwnProperty(entry)) {
          this.entries[entry] = new Entry({
            ...this.entries[entry],
            journal: this
          })
        }
      }
    }
  }
  toJSON() {
    var pack = {
      name: this.name,
      ownerUUID: this.ownerUUID,
      uuid: this.uuid,
      defaultText: this.defaultText,
      entries: this.entries
      // JSON.stringify will call .toJSON method on each individual
      // entry, which does not resupply journal object
    }
    return pack
  }
  getEntry(dateString) {
    if (!checkDateString(dateString)) {
      throw new TypeError('Invalid DateString passed to getEntry.')
    }
    if (this.entries.hasOwnProperty(dateString)) {
      return this.entries[dateString]
    } else {
      return this.createEntry(dateString)
    }
  }
  createEntry(dateString) {
    // produces a new entry object and adds it to entries
    this.entries[dateString] = new Entry({
      journal: this,
      content: this.defaultText, // default text of entry
      forDay: dateString,
      creationDateTime: new Date(), // current time
      modifiedDateTime: new Date(),
      tags: [],
      creationDeviceData: detect() // device data
    })
    return this.entries[dateString]
  }
  purge(dateString) {
    // validate
    if (!checkDateString(dateString)) {
      throw new TypeError('Invalid DateString passed to purge.')
    }

    // check if content is default or empty, if so, delete
    var content = this.getEntry(dateString).content;
    if (content == this.defaultText || content == '') {
      delete this.entries[dateString]
    }
  }
  forcePurge(dateString) {
    if (!checkDateString(dateString)) {
      throw new TypeError('Invalid DateString passed to forcePurge.')
    }
    // delete entry even if has content (list view)
    delete this.entries[dateString]
  }
}
